import styled, { css } from 'styled-components';

type ArticlesWrapperProps = {
  numberOfColumns: number;
};

export const gallery = css`
  width: 100%;
  padding: 1em 0 2em 0;
`;

export const white = css`
  background-color: var(--white);
  width: 100%;
  padding: 1em 0 2em 0;
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.02);
`;

export const transparent = css`
  background-color: transparent;
`;

export const CarouselContainerWrapper = styled.div`
  .carousel__slider {
    display: flex;
    height: 100%;
    .carousel__inner-slide {
      height: 100%;
    }
  }

  [data-testid^='card'] {
    height: 100%;
  }

  @media only screen and (min-width: 1025px) {
    ul.carousel__pagination {
      display: none;
    }
    .carousel__controls {
      display: none;
    }
  }
`;

export const CarouselItemWrapper = styled.div`
  text-align: left;

  [class*='Articlestyles__ArticleWrapper'] {
    height: 100%;
    a {
      height: 100%;
    }
  }
`;

export const CtaButtonWrapper = styled.div`
  margin-top: 34px;
  button {
    margin: 0;
  }
`;

export const ArticlesWrapper = styled.div<ArticlesWrapperProps>`
  display: grid;
  --columns: ${({ numberOfColumns }) => numberOfColumns};
  grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
  align-items: stretch;
  gap: 16px;

  div.featured-article-grid {
    grid-column: 1/-1;
  }

  @media (max-width: 794px) {
    --columns: 1;
  }
`;

export const IconsAndTextCardsWrapper = styled.div<ArticlesWrapperProps>`
display: grid;
--columns: ${({ numberOfColumns }) => numberOfColumns};
grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
align-items: stretch;
gap: 20px;

@media (max-width: 640px) {
  --columns: 1;
}
`;

export const CardsWrapper = styled.div<ArticlesWrapperProps>`
  margin: 0 100px;
  display: grid;
  --columns: ${({ numberOfColumns }) => numberOfColumns};
  grid-template-columns: repeat(var(--columns), minmax(auto, 1fr));
  align-items: stretch;
  gap: 20px;

  @media (max-width: 1024px) {
    margin: 50px;
  }

  @media (max-width: 840px) {
    margin: 0;
  }

  @media (max-width: 640px) {
    --columns: 1;
  }
`;

export const CaroulselWrapper = styled.div`
  [class*='CarouselArrowstyle__CarouselArrow-sc']:first-of-type {
    right: 103%;

    @media (max-width: 640px) {
      display: none;
    }
  }

  [class*='CarouselArrowstyle__CarouselArrow-sc']:last-of-type {
    left: 103%;

    @media (max-width: 640px) {
      display: none;
    }
  }
`;

export const RichTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  p {
    max-width: 650px;
  }
`;
